
import {isNotBlankOrNullString} from "../../utils/stringUtils";

class ListingParams {
    constructor(data) {
        const {
            lang,
            categoryIdList,
            categoryNameList,
        } = data ?? {};
        this.categoryIdList =isNotBlankOrNullString(categoryIdList) ?  categoryIdList.split(",") : [];
        this.categoryNameList =isNotBlankOrNullString(categoryNameList) ?  categoryNameList.split("}") : [];
        this.lang = lang ?? '';
    }
}

export default ListingParams;
